import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Section from "components/Section";
import Loader from "components/Loader";
// import { movieApi } from "api";
import Poster from "components/Poster"
import Popular from "../../components/Popular";
import PosterP from "../../components/PosterP";
import Helmet from "react-helmet";
const Container = styled.div`
    padding: 100px 50px 0 50px;
    margin-bottom: 50px;
    overflow: hidden;
`;


const TvPresenter = ({topRated, popular, airingToday,lastest, error, loading}) => 
loading ? 
<>
<Loader /> 
<Helmet>
    <title>loading...</title>
</Helmet>
</>
: 
<Container>
    <Helmet>
        <title>TV | DainFlix</title>
    </Helmet>
    {topRated && topRated.length > 0 && <Popular title="Top Rated Shows">{topRated.map((show, index) => <PosterP key={index} id={show.id} title={show.name} imageUrl={show.poster_path} year={show.first_air_date && show.first_air_date.substring(0,4)} rating={show.vote_average} isMovie={false} />)}</Popular>}
    {popular && popular.length > 0 && <Section title="Popular Shows">{popular.map((show, index) => <Poster key={index} id={show.id} title={show.name} imageUrl={show.poster_path} year={show.first_air_date && show.first_air_date.substring(0,4)} rating={show.vote_average} isMovie={false} />)}</Section>}
    {airingToday && airingToday.length > 0 && <Section title="AiringToday">{airingToday.map((show, index) => <Poster key={index} id={show.id} title={show.name} imageUrl={show.poster_path} year={show.first_air_date && show.first_air_date.substring(0,4)} rating={show.vote_average} isMovie={false} />)}</Section>}
    {lastest && lastest.length > 0 && <Section title="lastest">{lastest.map((show, index) => <Poster key={index} id={show.id} title={show.name} imageUrl={show.poster_path} year={show.first_air_date && show.first_air_date.substring(0,4)} rating={show.vote_average} isMovie={false} />)}</Section>}
</Container>

TvPresenter.prototype = {
    topRated: PropTypes.array,
    popular: PropTypes.array,
    airingToday: PropTypes.array,
    error: PropTypes.bool.isRequired,
    loading: PropTypes.string
}


export default TvPresenter;
